module.exports = __webpack_public_path__ + "media/f-2.bf6dd524.mp3";